module.exports = __webpack_public_path__ + "static/media/DocumentNew.88621b19.svg";